export default __webpack_public_path__ + "static/pragicts-ai-consulting-services-1973ac622c0f0391d56296f9f6c31f00.jpg";